export enum OrderingType {
  ByCatalogName = 'byNameCatalog',
  ByCatalogNameEn = 'byNamePublicCatalogEn',
  ByCategoryName = 'byNameCategory',
  ByCategoryNameEn = 'byNameOpenCategoryEn',
  ByProviderName = 'byNameOIV',
  ByNumberOfViews = 'byNumberView',
  ByRating = 'byRating'
}

type OrderingTypeValue = 'ASC' | 'DESC';

export type SortingType = {
  [key in OrderingType]?: OrderingTypeValue;
};

export type OrderingSelectOption = {
  title: string;
  isSelected: boolean;
  sorting: SortingType;
  sortingEn?: SortingType;
};
